import { dynamicImportHandlerFactory } from '@grantstreet/psc-vue/utils/logging.ts'
import { logDynamicImportException } from './sentry.ts'

export const handleDynamicImport = dynamicImportHandlerFactory({
  app: 'payables-ui',
  logException: logDynamicImportException,
})
